import React, { memo, useEffect, useState } from "react";
import { PainelProvider, usePainelContext } from "../PainelControle/PainelContext";
import DefaultCrudForm from "components/form/DefaultCrudForm";
import { Box, CircularProgress, Divider, IconButton, MenuItem, Tooltip, Typography } from "@mui/material";
import { dateHoraToStringIso, formatHoraDataLocal } from "util/date";
import { Edit } from "@mui/icons-material";
import { useUrlQueryUid2Field } from "components/form";
import { useNavigate, useSearchParams } from "react-router-dom";
import Rodada from "entity/Rodada";
import FormRow from "components/form/FormRow";
import DropDownButton from "components/DropDownButton";

import { formatDuration as formatDurationI, intervalToDuration } from "date-fns";
import pt from "date-fns/locale/pt-BR";
import AudioDialog from "./AudioDialog";
// add na url para teste "&teste=2024-09-04T15:10:00"
const velocidadeTeste = 5; // x Veses
const formatDuration = (duration) => {
    if (!duration) {
        return "00:00";
    }
    if (duration.days) {
        return formatDurationI(duration, {
            delimiter: ", ",
            locale: pt,
        });
    }

    let formatted = "";
    if (duration.hours) {
        formatted += `${duration.hours > 9 ? duration.hours : "0" + duration.hours}:`;
    }

    formatted += `${duration.minutes > 9 ? duration.minutes : "0" + duration.minutes}:${duration.seconds > 9 ? duration.seconds : "0" + duration.seconds
        } `;

    return formatted;
};

const HeaderReuniões = () => {
    let corUsar = "rgba(255, 255, 255, 0.3)";

    return (
        <Box
            sx={{
                backgroundColor: corUsar,
                boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
                width: 600,
                display: "flex",
                flex: 1,
                gap: 2,
                p: 1,
                m: 1,
            }}
        >
            <div style={{ flex: 1, display: "flex", justifyContent: "center" }}>
                <Typography variant="h6">{"Mesa"}</Typography>
            </div>

            <Divider orientation="vertical" flexItem />

            <div style={{ flex: 2, display: "flex", justifyContent: "center" }}>
                <Typography variant="h6">{"Participante 1"}</Typography>
            </div>

            <Divider orientation="vertical" flexItem />

            <div style={{ flex: 2, display: "flex", justifyContent: "center" }}>
                <Typography variant="h6">{"Participante 2"}</Typography>
            </div>
            <div style={{ width: 35, display: "flex", alignItems: "center" }}></div>
        </Box>
    );
};

const CardReuniao = ({ reuniao, proximaTroca, proximaTroca2, index }) => {
    let corUsar;

    if (proximaTroca === reuniao.horario.horario) {
        // PROXIMA
        if (index % 2) {
            corUsar = "rgba(255, 241, 0, 0.66)";
            // corUsar = "rgba(6, 99, 255 ,0.66)"
        } else {
            corUsar = "rgba(250, 240, 77, 0.5)";
            // corUsar = "rgba(92, 153, 255, 0.5)"
        }
    } else if (proximaTroca > reuniao.horario.horario) {
        // AGORA

        if (index % 2) {
            corUsar = "rgba(89, 255, 186, 0.66)";
        } else {
            corUsar = "rgba(153, 255, 205, 0.5)";
        }
    } else if (proximaTroca2 === reuniao.horario.horario) {
        // TERCEIRA COLUNA

        if (index % 2) {
            corUsar = "rgba(6, 99, 255 ,0.66)";
        } else {
            corUsar = "rgba(92, 153, 255, 0.5)";
        }
    } else {
        corUsar = "rgba(255, 255, 255, 0.3)";
        // status = ""
    }

    return (
        <Box
            className="hoverStart"
            sx={{
                backgroundColor: corUsar,
                boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
                width: 600,
                display: "flex",
                flex: 1,
                gap: 2,
                p: 1,
                m: 1,
            }}
        >
            {/* <div style={{ width: 150 }}>
            <div style={{ width: 150, display: "flex", justifyContent: "center" }}>
                <Typography
                    variant='caption'
                >
                    {status
                        ? " (" + status + ")"
                        : ""
                    }
                </Typography>
            </div>
            <div style={{ width: 150, display: "flex", justifyContent: "center" }}>
                <Typography variant='h6'>
                    {reuniao.horariotxt}
                </Typography>
            </div>

        </div> */}

            {/* <Divider orientation="vertical" flexItem /> */}

            <div style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center" }}>
                <Typography variant="h6" sx={{ textAlign: "center" }}>
                    {/* {reuniao.mesa.index
                    ? "MESA " + (reuniao.mesa.index)// + " - "
                    : `MESA ${(reuniao.rodada.mesas.map(m => m.uid)).indexOf(reuniao.mesa.uid) + 1}`// - `
                } */}
                    {reuniao.mesa.name}
                </Typography>
            </div>

            <Divider orientation="vertical" flexItem />

            <div style={{ flex: 2, display: "flex", alignItems: "center" }}>
                <Typography variant="h6">{`${reuniao.inscricao1.empresa.nomeEmpresaCracha}`}</Typography>
            </div>

            <Divider orientation="vertical" flexItem />

            <div style={{ flex: 2, display: "flex", alignItems: "center" }}>
                <Typography variant="h6">{`${reuniao.inscricao2.empresa.nomeEmpresaCracha}`}</Typography>
            </div>

            <div className="showHover" style={{ width: 35, display: "flex", alignItems: "center" }}>
                <Tooltip title="EDITAR">
                    <IconButton
                        onClick={() => {
                            window.open(`/#/reuniao?uid=${reuniao.uid}`, "_blank");
                            // navigate("/reuniao?uid=" + reuniao.uid)
                        }}
                    >
                        <Edit />
                    </IconButton>
                </Tooltip>
            </div>
        </Box>
    );
};

const CardHorarioR = ({ valueCard, label = "Agora", hora, reunioes, proximaTroca, proximaTroca2, rodada }) => {
    if (valueCard.intervalo) {
        return (
            <Box
                sx={{
                    backgroundColor: "#ccc",
                    boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
                    width: 600,
                    display: "flex",
                    flex: 1,
                    gap: 2,
                    p: 1,
                    m: 1,
                }}
            >
                <div>
                    <div style={{}}>
                        <Typography variant="h3">
                            <b>{valueCard.intervalo.obs}</b>
                        </Typography>
                        <Typography variant="h5">
                            <b>
                                Das: {hora} ás {formatHoraDataLocal(valueCard.intervalo.fim)}
                            </b>
                        </Typography>
                    </div>
                </div>
            </Box>
        );
    }

    return (
        <Box sx={{ display: "flex", flex: 1 }}>
            <div>
                <div style={{}}>
                    <Typography variant="caption">{label}</Typography>
                    <Typography variant="h3">
                        <b>{hora}</b>
                    </Typography>
                </div>

                <HeaderReuniões />

                {reunioes.length ? (
                    reunioes.map((r, i) => {
                        return (
                            <CardReuniao
                                reuniao={r}
                                key={i}
                                index={i}
                                proximaTroca={proximaTroca}
                                proximaTroca2={proximaTroca2}
                                rodada={rodada}
                            />
                        );
                    })
                ) : (
                    <Typography
                        sx={{ display: "flex", justifyContent: "center", color: "text.disabled", paddingTop: "1.5em" }}
                        variant="h6"
                    >
                        - NENHUMA REUNIÃO AGORA -
                    </Typography>
                )}
            </div>
        </Box>
    );
};

const DashboardReunioesRealtimeView = memo(function DashboardReunioesRealtimeView1({ rodada, reunioes, now }) {
    const navigate = useNavigate();

    const [openAudioDialog, setOpenAudioDialog] = useState(true);

    let tempoProxima = null;
    let timerColor = null;
    let tipoConter = null;

    const horaRefReunioes = dateHoraToStringIso(now);
    let proximoHorario = null;
    let proximoProximoHorario = null;
    let listaCardsExibir = [];

    if (rodada.intervalos && rodada.intervalos.length) {
        rodada.intervalos.forEach((i) => {
            if (i.fim > horaRefReunioes) {
                let mapR = { key: i.inicio, reunioes: [] };

                mapR.intervalo = i;
                mapR.hora = formatHoraDataLocal(i.inicio);
                listaCardsExibir.push(mapR);
            }
        });
    }

    const reunioesPendentes = reunioes.filter((r) => {
        let horaRefMantemAtual = horaRefReunioes
        let dt = new Date(horaRefMantemAtual)
        // let sub = parseInt(rodada.intervaloReuniao) + parseInt(rodada.tempoReuniao)
        let sub = parseInt(rodada.tempoReuniao)
        dt.setMinutes(dt.getMinutes() - (sub - 1))
        dt.setSeconds(59)
        horaRefMantemAtual = dateHoraToStringIso(dt)

        if (r.horario.horario >= horaRefMantemAtual) {
            if (
                r.inscricao1.status === "INSCRITO" &&
                r.inscricao1.statusEvento === "PRESENTE" &&
                r.inscricao2.status === "INSCRITO" &&
                r.inscricao2.statusEvento === "PRESENTE"
            ) {
                if (r.horario.horario > horaRefReunioes) {
                    if (proximoHorario == null || r.horario.horario < proximoHorario) {
                        proximoHorario = r.horario.horario;
                    }

                    if (
                        (proximoProximoHorario == null || r.horario.horario < proximoProximoHorario) &&
                        r.horario.horario > proximoHorario
                    ) {
                        proximoProximoHorario = r.horario.horario;
                    }
                }

                let mapR = listaCardsExibir.find((m) => m.key === r.horario.horario);

                if (!mapR) {
                    mapR = { key: r.horario.horario, reunioes: [] };
                    mapR.hora = formatHoraDataLocal(r.horario.horario);
                    listaCardsExibir.push(mapR);
                }

                mapR.reunioes.push(r);
                mapR.reunioes.sort((a, b) => (a.mesa.index > b.mesa.index ? 1 : -1));

                return true;
            } else {
                return false;
            }
        } else {
            return false;
        }
    });

    listaCardsExibir.sort((a, b) => {
        return a.key > b.key ? 1 : -1;
    });

    let horarioReuniaoAtual = "";
    let primeiraOuAtual = reunioesPendentes.length ? reunioesPendentes[0].horario.horario : "";

    if (new Date(primeiraOuAtual) <= now) {
        horarioReuniaoAtual = primeiraOuAtual;
    }

    //ajuste visual

    let d1 = new Date(proximoHorario);
    let d2 = new Date(horarioReuniaoAtual);
    if (horarioReuniaoAtual) {
        d2.setMinutes(d2.getMinutes() + parseInt(rodada.tempoReuniao));
    }

    if (!horarioReuniaoAtual && !proximoHorario && now <= new Date(rodada.dataInicio)) {
        let duration = intervalToDuration({ start: now, end: new Date(rodada.dataInicio) });
        tempoProxima = duration;
    } else if (horarioReuniaoAtual && now <= d2) {
        let duration = intervalToDuration({ start: now, end: d2 });
        tempoProxima = duration;
        tipoConter = "Em Reunião";
        timerColor = "#000";
    } else if (now <= d1) {
        let duration = intervalToDuration({ start: now, end: d1 });
        tempoProxima = duration;
        tipoConter = "Intervalo";
        if (horarioReuniaoAtual) {
            timerColor = "#00f";
        } else {
            timerColor = "#000";
        }
    } else {
        tipoConter = "Em Reunião";
        timerColor = "#000";
    }

    return (
        <div style={{ width: "100%" }}>
            <FormRow sx={{ flex: 1, pl: 1, pr: 1 }}>
                <div style={{ flex: 3, display: "flex" }}>
                    <div>
                        <Typography variant="caption">Rodada</Typography>
                        <Typography variant="h3">
                            <b>{rodada.nome?.toUpperCase()}</b>
                        </Typography>
                    </div>

                    <DropDownButton label="">
                        <MenuItem
                            onClick={() => {
                                navigate(`/painel-controle?rodada=${rodada.uid}`);
                            }}
                        >
                            Painel da Rodada
                        </MenuItem>
                        <MenuItem onClick={() => setOpenAudioDialog(true)}>Alerta Sonoro</MenuItem>
                    </DropDownButton>
                </div>
                <div style={{ flex: 1.5 }}></div>
                <div>
                    <Typography variant="caption">
                        Hora Atual
                    </Typography>
                    <Typography variant={"h3"}>
                        <b>{horaRefReunioes.split('T')[1]}</b>
                    </Typography>
                </div>
                <div
                    style={{
                        flex: 1,
                        alignItems: "center",
                        justifyContent: "center",
                        display: "flex",
                        flexDirection: "column",
                        boxShadow: "0 4px 8px 0 rgba(0,0,0,0.5)",
                        padding: 10,
                        background: "rgba(217, 255, 255, 0.5)",
                    }}
                >
                    {horarioReuniaoAtual ? (
                        <Typography variant="caption">
                            {tipoConter === "Intervalo" ? "Próxima Reunião em" : "Próximo intervalo em"}
                        </Typography>
                    ) : (
                        <Typography variant="caption">{"Inicia em:"}</Typography>
                    )}

                    <AudioDialog
                        tempoProxima={tempoProxima}
                        open={openAudioDialog}
                        setOpen={setOpenAudioDialog}
                        tipoConter={tipoConter}
                    />

                    <Typography color={timerColor} variant={tempoProxima && tempoProxima.days ? "inherit" : "h1"}>
                        <b>{formatDuration(tempoProxima)}</b>
                    </Typography>
                    {horarioReuniaoAtual && (
                        <Typography variant="h6">
                            <b>{tipoConter}</b>
                        </Typography>
                    )}
                </div>
            </FormRow>
            {reunioes == null && (
                <FormRow sx={{ flex: 1, alignItems: "center", justifyContent: "center" }}>
                    <CircularProgress />
                    <Typography>Carrengado reuniões...</Typography>
                </FormRow>
            )}
            <Box sx={{ display: "flex", overflow: "auto", transform: "rotateX(180deg)", maxWidth: "98vw", mt: 2 }}>
                <Box sx={{ display: "flex", transform: "rotateX(180deg)" }}>
                    {(listaCardsExibir || []).map((h, i) => (
                        <CardHorarioR
                            key={i}
                            label={horarioReuniaoAtual === h.key ? "Agora" : "Próxima"}
                            valueCard={h}
                            hora={h.hora}
                            reunioes={h.reunioes}
                            proximaTroca={proximoHorario}
                            proximaTroca2={proximoProximoHorario}
                            rodada={rodada}
                        />
                    ))}
                </Box>
            </Box>
            {/* {nestReunioes &&
<Box sx={{ display: "flex", flex: 1 }}>
    <div>

        {nestReunioes.length
            ? <>
                <div style={{}}>
                    <Typography variant='caption'>
                        Agora
                    </Typography>
                    <Typography variant='h3'>
                        <b>{formatHoraDataLocal(horaRefReunioes)}</b>
                    </Typography>
                </div>

                <HeaderReuniões />

                {nestReunioes.filter(rf => proximaTroca > rf.horario.horario).length
                    ? nestReunioes.filter(rf => proximaTroca > rf.horario.horario).map((r, i) => {
                        return (
                            <CardReuniao
                                reuniao={r}
                                key={i}
                                proximaTroca={proximaTroca}
                            />
                        )
                    })
                    : <Typography
                        sx={{ display: "flex", justifyContent: 'center', color: 'text.disabled', paddingTop: "1.5em" }}
                        variant="h6"
                    >
                        - NENHUMA REUNIÃO AGORA -
                    </Typography>
                }
            </>
            : <></>
        }

    </div>

    <div>


        {nestReunioes.length
            ? <>
                <div style={{}}>
                    <Typography variant='caption'>
                        Proxima Reunião
                    </Typography>
                    <Typography variant='h3'>
                        <b>{formatHoraDataLocal(proximaTroca) || "--:-- - --/--"}</b>
                    </Typography>
                </div>

                <HeaderReuniões />

                {nestReunioes.filter(rf => proximaTroca === rf.horario.horario).length
                    ? nestReunioes.filter(rf => proximaTroca === rf.horario.horario || proximaTroca < rf.horario.horario).map((r, i) => {
                        return (
                            <CardReuniao
                                reuniao={r}
                                key={i}
                                proximaTroca={proximaTroca}
                            />
                        )
                    })
                    : <Typography
                        sx={{ display: "flex", justifyContent: 'center', color: 'text.disabled' }}
                        variant="h6"
                    >
                        - NENHUMA REUNIÃO -
                    </Typography>
                }
            </>
            : <></>
        }


    </div>
</Box>
} */}
            {/* <AudioDialog
                tempoProxima={tempoProxima}
                open={openAudioDialog}
                setOpen={setOpenAudioDialog}
                tipoConter={tipoConter}
            /> */}
        </div>
    );
});

const DashboardReunioesRealtimeTimeControl = memo(function DashboardReunioesRealtimeTimeControl({ rodada, reunioes }) {
    const [searchParams] = useSearchParams();
    let testeK = searchParams.get("teste");
    let testTime = new Date(testeK);
    const [now, setNow] = useState(testTime);

    const [counterSegundosTeste, setCounterSegundosTeste] = React.useState(0);

    useEffect(() => {
        function refreshTime() {
            if (!testeK) {
                let now = new Date();
                setNow(now);
            }
        }

        setInterval(refreshTime, 1000);

        return () => { };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    //teste timer acelerado
    React.useEffect(() => {
        if (testeK) {
            if (counterSegundosTeste > 59) {
                let newD = new Date(now);
                newD.setMinutes(newD.getMinutes() + 1);
                newD.setSeconds(0);
                setNow(newD);
                setCounterSegundosTeste(0);
            } else {
                setTimeout(() => setCounterSegundosTeste((old) => old + 1), 1000 / velocidadeTeste);
                let newD = new Date(now);
                newD.setSeconds(counterSegundosTeste);
                setNow(newD);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [counterSegundosTeste, testeK]);

    reunioes.sort((a, b) => {
        let aH = a.horariotxt.split("-").reverse().join("");
        let bH = b.horariotxt.split("-").reverse().join("");
        if (aH === bH) {
            return a.mesa?.name > b.mesa?.name ? 1 : -1;
        }

        return aH > bH ? 1 : -1;
    });
    return <>{now && <DashboardReunioesRealtimeView rodada={rodada} reunioes={reunioes} now={now} />}</>;
});
function DashboardReunioesRealtime(props) {
    const { rodada } = props.values;

    useUrlQueryUid2Field("rodada", "rodada", Rodada, props.form);

    console.log("rodada", rodada);

    const { startListnersRodada, reunioes } = usePainelContext();
    useEffect(() => {
        let observers = [];
        console.log("useEffect startListnersRodada ");
        if (rodada) {
            observers = startListnersRodada(rodada);
        }

        return () => {
            observers.forEach((o) => {
                if (o) o();
            });
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [rodada]);

    return <>{rodada ? <DashboardReunioesRealtimeTimeControl rodada={rodada} reunioes={reunioes} /> : "Carregando"}</>;
}

export default function DashboardReuniaoNow() {
    return (
        <DefaultCrudForm
            title={"Dashboard - Tempo Real1"}
            formActions={{ novoForm: false, salvarForm: false, sairForm: false }}
            contentProps={{ sx: { p: 1 } }}
        >
            {(props) => {
                return (
                    <PainelProvider>
                        <DashboardReunioesRealtime {...props} />
                    </PainelProvider>
                );
            }}
        </DefaultCrudForm>
    );
}
